import { physicalDto } from '../dto/physicalDto';
import { tableViewModel } from '../views/tableViewModel';
import { hypervisorPlatformCountDto } from '../dto/hypervisorPlatformCountDto';

export class physicalHostsTransformer {
  public static from(physicalHostsData: physicalDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'Host Platform(s)',
        value:
          physicalHostsData.hostPlatformName == null
            ? '-'
            : hostPlatformParsing(
                physicalHostsData.hostPlatformName,
                physicalHostsData.hypervisorPlatformCount
              )
      },
      {
        name: 'Hosts',
        value: physicalHostsData.hostCount == null ? '-' : physicalHostsData.hostCount
      },
      {
        name: 'CPUs',
        value: physicalHostsData.hostCPUCount == null ? '-' : physicalHostsData.hostCPUCount
      }
    ];
    function hostPlatformParsing(name: string, platformCount: hypervisorPlatformCountDto) {
      let platformsCount = 0;
      platformCount.esx != 0 ? platformsCount++ : platformsCount;
      platformCount.hyperV != 0 ? platformsCount++ : platformsCount;
      platformCount.other != 0 ? platformsCount++ : platformsCount;
      return platformsCount <= 1 ? (name == null ? '-' : name) : platformsCount;
    }
  }
}
